.about-container {
    .about-panel {
        position: relative;
        width: 26px;
        height: 26px;
        margin-left: 33px;
        display: inline-block;
        .btn {
            background: inherit;
            border: none;
            i {
                font-size: 26px;
                color: #fff;
            }
        }
        .detail-img {
            display: none;
            position: absolute;
            top: -156px;
            left: -58px;
            padding: 10px;
            background: #fff;
            border-radius: 4px;
            box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.16);
            img {
                width: 136px;
                height: 136px;
                max-width: none;
            }
            &:after {
                content: '';
                width: 10px;
                border-top: solid 10px #fff;
                border-right: solid 10px rgba(0, 0, 0, 0);
                border-bottom: solid 10px rgba(0, 0, 0, 0);
                border-left: solid 10px rgba(0, 0, 0, 0);
                position: absolute;
                bottom: -20px;
                left: 50%;
                margin-left: -5px;
            }
        }
    }
    .about-panel:hover {
        .detail-img {
            display: block;
        }
        .btn i {
            color: #666;
        }
    }
}
